var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaleIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 65,
    viewBox: "0 0 31 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7229_60629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 7.76562C22 11.6413 18.8625 14.7656 15 14.7656C11.1375 14.7656 8 11.6281 8 7.76562C8 3.9031 11.1243 0.765625 14.9868 0.765625C18.8493 0.765625 21.9868 3.9031 21.9868 7.76562H22Z",
    fill: "url(#paint0_linear_7229_60629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7288 16.7656H7.28561C2.94403 16.7656 -0.43116 20.0364 0.0448281 23.769L1.80454 37.5635C2.07859 39.6608 4.12678 41.2462 6.56442 41.2462L8.6126 61.2951C8.81454 63.2551 10.7185 64.7656 12.983 64.7656H18.017C20.2959 64.7656 22.1999 63.2551 22.3874 61.2951L24.4356 41.2462C26.8732 41.2462 28.9214 39.6608 29.1955 37.5635L30.9552 23.769C31.4312 20.0364 28.056 16.7656 23.7144 16.7656H23.7288Z",
    fill: "url(#paint1_linear_7229_60629)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7229_60629",
    x1: 11.4011,
    y1: 4.17994,
    x2: 69.8795,
    y2: 62.6715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DBCA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6891CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7229_60629",
    x1: -4.29676,
    y1: 20.6356,
    x2: 47.8997,
    y2: 80.9583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DBCA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6891CB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7229_60629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 64,
    fill: "white",
    transform: "translate(0 0.765625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleIcon);
export default __webpack_public_path__ + "static/media/maleIcon.4997a7909249d8660d1e3792af02a46c.svg";
export { ForwardRef as ReactComponent };